import CodeMirror from './codemirror/lib/codemirror.js';
import './codemirror/mode/xml/xml.js';
import './codemirror/lib/codemirror.css';
import './codemirror/theme/material-darker.css';
import './codemirror/theme/dracula.css';

(function() {
  const input = document.querySelector('input[type=file]')
  const result = document.getElementById('result')
  const preview = document.querySelector('.preview')
  const themeToggle = document.getElementById('theme-toggle')
  const html = document.documentElement
  const chooseFileBtn = document.querySelector('.choose-file-btn')
  const charCount = document.getElementById('char-count')
  const copyBtn = document.getElementById('copy')
  const downloadBtn = document.getElementById('download')
  
  // Theme handling
  const savedTheme = localStorage.getItem('theme') || 'light'
  html.setAttribute('data-theme', savedTheme)
  
  function updateCodeMirrorTheme(theme) {
    if (editor) {
      editor.setOption('theme', theme === 'dark' ? 'dracula' : 'default')
    }
    if (outputEditor) {
      outputEditor.setOption('theme', theme === 'dark' ? 'dracula' : 'default')
    }
  }

  themeToggle.addEventListener('click', () => {
    const currentTheme = html.getAttribute('data-theme')
    const newTheme = currentTheme === 'light' ? 'dark' : 'light'
    html.setAttribute('data-theme', newTheme)
    localStorage.setItem('theme', newTheme)
    updateCodeMirrorTheme(newTheme)
  })

  let theme = savedTheme === 'dark' ? 'dracula' : 'default'

  const editor = CodeMirror.fromTextArea(result, {
    lineNumbers: true,
    mode: {
      name: 'xml'
    },
    theme: theme,
    tabSize: 2
  })

  // Output editor (read-only)
  const outputContainer = document.querySelector('.formatted-code-container')
  outputContainer.innerHTML = '' // Clear placeholder
  const outputEditor = CodeMirror(outputContainer, {
    value: '',
    mode: { name: 'xml' },
    theme: theme,
    lineNumbers: true,
    readOnly: true,
    tabSize: 2
  })

  editor.on('change', function(editor) {
    const value = editor.getValue()
    readFile(value)
    updateCharCount(value)
  })

  function updateCharCount(text) {
    if (charCount) {
      charCount.textContent = `${text.length} characters`
    }
  }

  function svgDataURL(svg) {
    const svgAsXML = (new XMLSerializer).serializeToString(svg)
    return 'data:image/svg+xml,' + encodeURIComponent(svgAsXML)
  }

  function readFile(event) {
    const value = (event && event.target && event.target.result) || event
    if (event && event.target && event.target.result) {
      editor.setValue(value)
    }
    
    // Handle empty value
    if (!value) {
      if (copyBtn) copyBtn.setAttribute('disabled', true)
      preview.innerHTML = `
        <div class="empty-state">
          <div class="check-circle">
            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>
          </div>
          <p>Your SVG will appear here</p>
        </div>
      `
      outputEditor.setValue('')
      return
    }

    const fragment = document.createRange().createContextualFragment(value)
    if (fragment.querySelector('svg')) {
      preview.innerHTML = value
      code = value
      outputEditor.setValue(value)
      if (copyBtn) copyBtn.removeAttribute('disabled')
      const svg = preview.querySelector('svg')
      if (downloadBtn) {
        downloadBtn.href = svgDataURL(svg)
        downloadBtn.setAttribute('download', 'image.svg')
      }
    } else {
      // Don't show error for empty lines or partial input during typing
      if (value.trim().length > 0) {
         // Optional: show error state
      }
    }
  }

  function changeFile() {
    const files = Array.from(input.files)
    const readers = files.map(file => {
      return new Promise((resolve) => {
        const reader = new FileReader()
        reader.addEventListener('load', (e) => resolve(e.target.result))
        reader.readAsText(file)
      })
    })

    Promise.all(readers).then(contents => {
      const combined = contents.join('\n\n')
      editor.setValue(combined)
    })
  }

  let code = ''

  function handleCopy (e) {
    window.navigator.clipboard.writeText(code)
    const originalHTML = e.currentTarget.innerHTML
    e.currentTarget.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg> Copied!`
    setTimeout(() => {
      e.currentTarget.innerHTML = originalHTML
    }, 2000)
  }

  function handleDownload (e) {
    if (!e.currentTarget.getAttribute('href')) {
      e.preventDefault()
    }
  }

  // Handle custom file button
  if (chooseFileBtn) {
    chooseFileBtn.addEventListener('click', () => {
      input.click()
    })
  }

  input.addEventListener('change', changeFile)
  if (copyBtn) copyBtn.addEventListener('click', handleCopy)
  if (downloadBtn) downloadBtn.addEventListener('click', handleDownload)
})()